/**
 * @file toast组件对外出口
 * @author (zhangwenting)
 */

/* global document */

import React from 'react';
import ReactDOM from 'react-dom';

import { classPrefix } from '../../common/util';

import Toast from './Toast';

function display(config) {
    var body = document.body;
    var toast = document.querySelector('.' + classPrefix + '-toast-block > .toast');
    var container = document.createElement('div');
    if (!toast) {
        var div = document.createElement('div');
        div.innerHTML = '<div class="' + classPrefix + '-toast-block"\n                              style="z-index:' + (config.level || 999) + '">\n\n                              <span class="toast"></span>\n                         </div>';
        body.appendChild(div);
        toast = document.querySelector('.' + classPrefix + '-toast-block > .toast');
    } else {
        toast.parentNode.style.zIndex = config.level;
    }
    var close = function close(callBack) {
        if (container) {
            ReactDOM.unmountComponentAtNode(container);
            toast.removeChild(container);
        }
        if (callBack) {
            callBack();
        }
    };
    if ('onCancel' in config) {
        config.onCancel = close.bind(this, config.onCel);
    } else {
        config.onCancel = close;
    }
    toast.appendChild(container);
    ReactDOM.render(React.createElement(Toast, config), container);
}

var m = Toast;
m.display = display;
export default m;